import { c as _c } from "react/compiler-runtime";
const BAR = "rounded-full bg-black/[0.06] dark:bg-white/[0.08]";

/** Placeholder shaped like DoctorCard while the list loads. */
export default function DoctorCardSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-16 h-16 shrink-0 rounded-full bg-black/[0.06] dark:bg-white/[0.08]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-start gap-3.5">{t0}<div className="flex-1 pt-1 space-y-2"><div className={`h-3.5 w-36 ${BAR}`} /><div className={`h-2.5 w-full ${BAR}`} /><div className={`h-2.5 w-2/3 ${BAR}`} /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex gap-1.5"><div className={`h-6 w-16 ${BAR}`} /><div className={`h-6 w-20 ${BAR}`} /><div className={`h-6 w-14 ${BAR}`} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="doctor-card-spring animate-pulse motion-reduce:animate-none p-4 sm:p-5 rounded-3xl flex flex-col gap-3.5" aria-hidden="true">{t1}{t2}<div className="flex items-center justify-between pt-3.5 border-t border-black/[0.06] dark:border-white/[0.08]"><div className={`h-3 w-24 ${BAR}`} /><div className="h-10 w-32 rounded-full bg-black/[0.06] dark:bg-white/[0.08]" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}